import { toolsIcon } from '@workday/canvas-system-icons-web'
import { createIcon } from './create-icon'
import { canvasIconPaths } from './canvasIconPaths'

export const Wrench = createIcon({
  displayName: 'Wrench',
  paths: [
    'M721.028 371.161l116.437-116.437c38.485 65.408 30.251 150.741-25.899 206.934-76.032 75.989-205.952 65.323-266.795-32.128-33.408-53.42-33.365-123.905 0.085-177.324 52.608-84.053 155.989-102.741 232.277-57.813l-116.437 116.352c-16.64 16.683-16.64 43.733 0 60.416 16.683 16.597 43.691 16.597 60.331 0zM268.51 763.349c16.683 16.683 43.648 16.64 60.331 0l180.992-181.035c16.683-16.683 16.683-43.691 0-60.331-16.64-16.683-43.648-16.683-60.331 0l-180.992 180.992c-16.683 16.683-16.683 43.691 0 60.373zM389.171 461.653c50.005-50.006 131.029-50.006 181.035 0 49.963 50.005 49.963 131.029 0 180.992l-181.035 181.035c-50.005 49.963-131.029 49.963-180.992 0-50.005-50.005-50.005-131.029 0-181.035l180.992-180.992z'
  ],
  canvasPaths: canvasIconPaths(toolsIcon)
})
